import Promise from 'bluebird';

Promise.config({
	cancellation: true,
	warnings: false, // too many unnecessary warnings
});

window.sis = {
	...window.sis,
	Promise,
};